import * as Domain from './domain'

export const stateSerializationModules = [
  Domain.stateSerializationDomainModule
]
